export default __webpack_public_path__ + "static/media/gate2.060dd224.jpeg";